import React from 'react'
import styled from 'styled-components'

    const FooterText  = styled.p`

    text-align: center;
    margin: 80px auto 10px;

    font-size: 14pt;

    line-height: 24pt;


    
    `

    const Footer = () => {

    return(

    <FooterText>
    Distributed with an MIT License <br/>
    benjamin j friedrich &#169; {(new Date()).getFullYear()} 
    
    
    </FooterText>

    )
 
    }

    export default Footer